/* eslint-disable indent */
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ItemPedido } from '../models/pedido';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { PremissasService } from '../services/premissas.service';
import { PremissasSistema } from '../models/premissas-sistema';
import { TipoCalculoMarkup } from '../models/enum';
import { GlobalService } from "../services/global.service";
import { IndicadorAnaliseDescontoService } from "../services/indicador-analise-desconto.service";
import { UsuarioLogado } from "../models/usuario-logado";
import { CalculoIndicador, IndicadorAnaliseDesconto } from "../models/indicador-analise-desconto";
import { PremissasUsuario } from '../models/premissas-usuario';
import { FreteService } from '../services/frete.service';
import { Frete } from '../models/frete';

@Component({
  selector: 'app-margem-lucro',
  templateUrl: './margem-lucro.component.html',
  styleUrls: ['./margem-lucro.component.scss']
})
export class MargemLucroComponent implements OnInit, OnChanges {

  @Input() itens: ItemPedido[];
  @Input() descontoIndividual: boolean;
  @Input() valorTotal: number;
  @Input() valorFinal: number;
  @Input() aliqImpRef: number;
  @Input() da: number;
  @Input() valorDa: number;
  @Input() versaoLayout: number;
  @Input() valorFrete: number;
  @Input() taxaDa: number;
  @Input() valorRepasse: number;
  @Input() taxaCondicaoPagamento: number;
  @Input() pFreteAdicionarServico: boolean;
  @Input() pUsarValorProjeto: boolean;
  @Input() valorServico: number;
  @Input() valorProjeto: number;
  @Input() kitProntoFrete: boolean;
  @Input() usarTbFrete: boolean;
  @Input() origem: number;
  @Input() frete: Frete;
  @Input() idFornecedor: number;
  @Input() ipi: number;
  @Input() podeVerIpi: boolean;
  @Input() idCupom: string;

  custoProdutos = 0;
  valorMinimo = 0;
  margem = 0;
  descontoMaximo = 0;
  descontoMaximoPerc = 0;

  premissasSistema = new PremissasSistema();
  premissasUsuario = new PremissasUsuario();

  faixasIndicador: IndicadorAnaliseDesconto[] = [];
  indicador: IndicadorAnaliseDesconto = null;
  usuarioLogado: UsuarioLogado;
  valorTempMarkup: number = 0;

  precoDeVendaAVistaSemRepasse = 0;
  valorTotalPedidoSemJuros = 0;
  valorPisCofins = 0;
  valorMargemContribuicao = 0;
  percentualFrete = 0;

  expandido = false;

  verCustos = undefined;
  cor: string = 'default';

  constructor(
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private premissasService: PremissasService,
    private globalService: GlobalService,
    private indicadorService: IndicadorAnaliseDescontoService,
    private freteService: FreteService
  ) { }

  async ngOnInit() {
    this.usuarioLogado = await this.globalService.consultaUsuario();
    this.verCustos = this.usuarioLogado.verCustos;

    await this.buscarPremissasSistema();
    await this.buscarPremissasUsuario();
    await this.buscarFaixasIndicador();

    this.calcularValoresCalculadoraMargem();
  }

  async buscarFaixasIndicador() {
    this.carregandoService.mostra('buscarFaixasIndicador');
    this.indicadorService.consultarLista().subscribe(data => {
      this.faixasIndicador = data;
      this.carregandoService.esconde('buscarFaixasIndicador');
    }, (erro) => {
      this.carregandoService.esconde('buscarFaixasIndicador');
      this.notificacaoService.erro(erro);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.calcularValoresCalculadoraMargem();
  }

  calcularValoresCalculadoraMargem() {

    this.custoProdutos = 0;
    let valorTotalItens = 0;

    this.itens.forEach(p => {
      this.custoProdutos += (p.pCusto !== null && p.pCusto !== undefined && Number(p.pCusto) > 0 ? Number(p.pCusto) : Number(p.produtoTela.precoCusto)) * Number(p.qt.toString().replace(',', '.'));
      valorTotalItens += p.vTotal;
    });

    this.valorMinimo = this.custoProdutos + ((Number(this.custoProdutos) / (1 - Number(this.margem) / 100)) - Number(this.custoProdutos));

    if (!this.descontoIndividual) {
      this.descontoMaximo = this.verCustos !== 'S' ? 0 : this.valorTotal - this.valorMinimo;
      this.descontoMaximoPerc = this.verCustos !== 'S' ? 0 : (100 * this.descontoMaximo) / this.valorTotal;
    }
    else {
      this.descontoMaximo = this.verCustos !== 'S' ? 0 : valorTotalItens - this.valorMinimo;
      this.descontoMaximoPerc = this.verCustos !== 'S' ? 0 : (100 * this.descontoMaximo) / valorTotalItens;
    }

    const valorDescontoPagamento = this.taxaDa < 0 ? this.taxaDa : 0;

    this.precoDeVendaAVistaSemRepasse = this.valorTotal + (this.da === 0 ? (Number(this.valorDa) * -1) : Number(this.valorDa)) + Number(this.valorFrete) + valorDescontoPagamento; //  this.valorFinal - this.taxaDa - Number(this.valorRepasse);
    this.valorTotalPedidoSemJuros = this.valorTotal + (this.da === 0 ? (Number(this.valorDa) * -1) : Number(this.valorDa)) + Number(this.valorFrete) + Number(this.valorRepasse); // valorFinal - this.taxaDa;
    this.valorPisCofins = this.valorFinal * this.premissasUsuario.aliquotaPisCofins / 100; // Pegar Premissa no Back
    this.valorMargemContribuicao = this.precoDeVendaAVistaSemRepasse - (this.custoProdutos + Number(this.valorFrete) + this.valorPisCofins);
    this.percentualFrete = (Number(this.valorFrete) / this.precoDeVendaAVistaSemRepasse) * 100;

    // this.calcularPercentualFrete();

    // console.log('dados:', this);
    this.buscaValorMarkup();
  }

  calcularPercentualFrete() {
    let valorComDa = 0;

    if (this.da == 0) {
      valorComDa = (Number(this.valorTotal)) - (Number(this.valorDa)) + (this.pFreteAdicionarServico ? (Number(this.valorServico)) : 0) + (this.pUsarValorProjeto ? (Number(this.valorProjeto)) : 0);
    }
    else {
      valorComDa = (Number(this.valorTotal)) + (Number(this.valorDa)) + (this.pFreteAdicionarServico ? (Number(this.valorServico)) : 0) + (this.pUsarValorProjeto ? (Number(this.valorProjeto)) : 0);
    }

    if (valorComDa < 0) valorComDa = 0;

    const naoCalcularFrete = (!this.kitProntoFrete && this.origem === 1) || !this.usarTbFrete;

    this.percentualFrete = naoCalcularFrete ? 0 : this.freteService.buscarDescontoDoFrete(this.frete, valorComDa);
  }

  calcularMarkup() {
    switch (this.premissasSistema.tipoCalculoMarkup) {
      case TipoCalculoMarkup.Simples:
        {
          let subTotal = 0;

          if (this.da === 0) {
            subTotal = Number((this.valorTotal - Number(this.valorDa)).toFixed(2));
          } else {
            subTotal = Number((this.valorTotal + Number(this.valorDa)).toFixed(2));
          }

          this.valorTempMarkup = (((subTotal - ((subTotal * this.aliqImpRef) / 100)) / this.custoProdutos) - 1) * 100;

          return this.valorTempMarkup;
        }

      case TipoCalculoMarkup.Composto:
        {
          const vlMk =

            (((Number(this.valorFinal) - Number(this.valorRepasse) - Number(this.valorFrete)) * (1 - Number(this.aliqImpRef) / 100) -
              ((Number(this.valorTotal) + Number(this.valorRepasse) + Number(this.valorFrete) - Number(this.valorDa) + Number(this.taxaDa)) *
                (Number(this.taxaDa) / (Number(this.valorTotal) + Number(this.valorRepasse) + Number(this.valorFrete) - Number(this.valorDa))))) /
              Number(this.custoProdutos) - 1) * 100;

          this.valorTempMarkup = vlMk;

          return vlMk;
        }

      default:
        return 0;
    }
  }

  faixaMarkup(markup: number) {
    if (!this.faixasIndicador || this.faixasIndicador.length === 0) {
      this.indicador = null;
      return;
    }

    const valor = Number(this.valorTempMarkup.toFixed(3));

    return this.faixasIndicador.find(i =>
      valor >= i.de && valor <= i.ate
    ).cor || "default";
  }

  buscaValorMarkup() {
    // this.carregandoService.mostra('buscaValorMarkup');

    const objeto: {
      itens: ItemPedido[];
      valorTotal: number;
      valorFinal: number;
      subTotal: number;
      aliqImpRef: number;
      da: number;
      valorDa: number;
      valorFrete: number;
      taxaDa: number;
      valorRepasse: number;
      idFornecedor: number;
      idCupom: string;
    } = {
      itens: this.itens,
      valorTotal: this.valorTotal,
      valorFinal: this.valorFinal,
      subTotal: 0,
      aliqImpRef: this.aliqImpRef,
      da: this.da,
      valorDa: this.valorDa,
      valorFrete: this.valorFrete,
      taxaDa: this.taxaDa,
      valorRepasse: this.valorRepasse,
      idFornecedor: this.idFornecedor,
      idCupom: ''
    };

    this.indicadorService.calculoIndicador(objeto).subscribe(async data => {
      this.cor = await data.text;
    }, (erro) => {
      this.cor = erro.error.text;
    });
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  async buscarPremissasUsuario() {
    try {
      this.carregandoService.mostra('buscarPremissasUsuario');
      this.premissasUsuario = await this.premissasService.consultarPremissasUsuario().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasUsuario');
    }
  }

  ehFreteMinimo() {
    return this.frete && this.frete.freteMinimo === Number(this.valorFrete);
  }
}
